<template>
  <el-dialog
    title="重置密码"
    :visible.sync="visible"
    top="29vh"
    width="500px"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div v-loading="isLoading">
      <el-form
        ref="ruleForm"
        class="ruleForm"
        :model="form"
        :rules="rules"
        label-position="right"
        label-width="auto"
      >
        <el-form-item label="账号密码" prop="secret">
          <div class="line">
            <el-input
              v-model="form.secret"
              placeholder="请输入账号密码"
              maxlength="32"
              clearable
            ></el-input>
            <span class="random" @click="handleRandomSecret">随机生成</span>
          </div>
        </el-form-item>
      </el-form>
      <p class="submit fn-text-center">
        <el-button type="primary" @click="handlerAddData('ruleForm')"
          >提交</el-button
        >
      </p>
    </div>
  </el-dialog>
</template>

<script>
import { generatePassword } from "@/utils/public.js";
export default {
  props: {
    infoId: {
      type: String,
      required: true
    }
  },
  data() {
    const isEmpty = (
      message = "该项值不能为空",
      trigger = ["blur", "change"]
    ) => {
      return {
        required: true,
        message,
        trigger
      };
    };
    return {
      visible: true,
      form: {
        secret: ""
      },
      rules: {
        secret: [
          isEmpty("请输入账号密码"),
          {
            validator: (rule, value, callback) => {
              // 校验长度
              if (!/.{6,32}/.test(value)) {
                return callback(new Error("请输入长度为6~32的密码"));
              }
              // // 校验复杂度
              // const complex = [
              //   /[a-zA-Z]/.test(value),
              //   /[0-9]/.test(value),
              //   /[^a-zA-Z0-9]/.test(value)
              // ].reduce((acc, cur) => {
              //   return acc + (cur ? 1 : 0);
              // }, 0);
              // if (complex < 2) {
              //   return callback(
              //     new Error("数字、大小写字母和特殊字符最少包含两种")
              //   );
              // }
              callback();
            },
            trigger: "blur"
          }
        ]
      },
      isLoading: false
    };
  },
  created() {},
  methods: {
    handleRandomSecret() {
      this.form.secret = generatePassword();
    },
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    // 正向处理数据 将数据处理后提交
    processDataSubmit() {
      return this.form;
    },
    // 逆向处理数据 获取后进行数据处理回显
    downloadProcessData(data) {
      return data;
    },
    // 点击添加数据按钮
    handlerAddData(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadAddData();
        }
      });
    },
    // 加载添加数据接口
    loadAddData() {
      this.isLoading = true;
      const params = this.processDataSubmit();
      this.$api("privilege", "modAccountPWD", {
        ...params,
        id: this.infoId
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.line {
  display: flex;
  .el-input {
    flex: 1;
  }
  .random {
    width: 82px;
    line-height: 40px;
    text-align: right;
    font-size: 14px;
    color: #409eff;
    cursor: pointer;
  }
}
</style>
